<template>
    <div class="contact-campaigns">
        <template v-if="!hasCampaigns">
            <div class="contact-view__no-data">Contact has no campaigns</div>
        </template>
        <template v-else>
            <contact-campaign
                v-for="campaign in campaigns"
                :key="campaign.id"
                :campaign="campaign"
                data-test="contact-campaign"
            ></contact-campaign>
        </template>
    </div>
</template>

<script setup>
import { computed,ref } from 'vue';
import ContactCampaign from './ContactCampaign.vue';
import { useToasted } from '../../../composables/useToasted';
import contactsClient from '../../../services/contactsClient';

const props = defineProps({
    contact: {
        type: Object,
        required: true,
    },
});


const $toasted = useToasted();

const campaigns = ref([]);
const isLoading = ref(false);

const hasCampaigns = computed(() => campaigns.value.length > 0);

const loadCampaigns = () => {
    isLoading.value = true;

    contactsClient.listCampaigns(Spark.state.currentTeam.id, props.contact.id)
        .then(({ data }) => {
            campaigns.value = [...campaigns.value, ...data.data];
        })
        .catch(() => {
            $toasted.global.platform_error();
        })
        .finally(() => {
            isLoading.value = false;
        });
};


loadCampaigns();
</script>

<style lang="scss">
.contact-campaigns {
    display: flex;
    flex-direction: column;
}
</style>
